import { MultilinkStoryblok } from "@/types/sb-component-types"

type StoryblokLinkType = "url" | "story" | "email" | "asset"

/**
 * This function takes a StoryblokLink or string and returns an object with href and target options for
 * use in a link.
 * @param {MultilinkStoryblok | string} [link] - The `link` parameter is an optional object that represents
 * a link in Storyblok CMS. It can contain properties such as `linktype`, `cached_url`, `url`, `email`,
 * `anchor`, and `target`. It can also be a string representing a URL.
 * @returns The function `getStoryblokLinkProps` returns an object with `href` and `target`
 * properties. The `href` property is a string representing the URL of the link, and the `target`
 * property is an object containing the `target` and `rel` attributes for the link. If the `link`
 * parameter is not provided, the function returns an object with a default
 */
export const getStoryblokLinkProps = (link?: MultilinkStoryblok) => {
  if (!link) {
    return {
      href: "",
    }
  }

  const { linktype, cached_url: cachedUrl, url, email, anchor, target } = link

  const cachedUrlWoithoutLeadingSlash = cachedUrl?.replace(/^\//, "")

  const storyblokLinkOptions: Record<StoryblokLinkType, string> = {
    story: `/${cachedUrlWoithoutLeadingSlash}` || "",
    url: url ?? "",
    email: `mailto:${email}`,
    asset: url ?? "",
  }

  const anchorID = anchor ? `#${anchor}` : ""
  const href = storyblokLinkOptions[linktype!] + anchorID

  return {
    href,
    target,
  }
}
